import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import matter from 'gray-matter';
import './Blog.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [content, setContent] = useState('');
  const [frontMatter, setFrontMatter] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    setContent('');
    setError(null);
    fetch(`${process.env.PUBLIC_URL}/posts/${slug}.md`)
      .then((res) => {
        if (!res.ok) throw new Error('Post not found');
        return res.text();
      })
      .then((text) => {
        const { data, content } = matter(text);
        setFrontMatter(data || {});
        setContent(content);
      })
      .catch((err) => {
        console.error(err);
        setError('Sorry, this post could not be loaded.');
      });
  }, [slug]);

  if (error) return <p>{error}</p>;
  if (!content) return <p>Loading...</p>;

  return (
    <article id="main-content" className="blog-post-container">
      <Link to="/blog" className="back-link">← Back to Writing</Link>
      {frontMatter.title && <h1 style={{ fontSize: '2rem', fontWeight: '600', marginBottom: '0.5rem', color: '#ffffff' }}>{frontMatter.title}</h1>}
      {frontMatter.date && (
        <p className="blog-meta">
          {new Date(frontMatter.date).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
          })}
        </p>
      )}
      <div className="blog-markdown"><ReactMarkdown remarkPlugins={[remarkGfm]}>
        {content}
      </ReactMarkdown></div>
    </article>
  );
};

export default BlogPost; 